import { render } from "./Index.vue?vue&type=template&id=7e768de9&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7e768de9"

export default script